module.exports = __webpack_public_path__ + "ClientApp/content/Beginning-to-heal.jpg";